export const ATTRIBUTION_STORAGE_KEY = 'oscair_attribution';

const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign'];

function getSessionStorage() {
  if (typeof window === 'undefined') return null;
  try {
    return window.sessionStorage || null;
  } catch (err) {
    console.warn('OscAir attribution storage is unavailable:', err);
    return null;
  }
}

function readStoredAttribution() {
  const storage = getSessionStorage();
  if (!storage) return {};

  try {
    const raw = storage.getItem(ATTRIBUTION_STORAGE_KEY);
    if (!raw) return {};
    return JSON.parse(raw) || {};
  } catch (err) {
    console.warn('OscAir attribution could not be read:', err);
    return {};
  }
}

function writeStoredAttribution(attribution) {
  const storage = getSessionStorage();
  if (!storage) return;

  try {
    storage.setItem(ATTRIBUTION_STORAGE_KEY, JSON.stringify(attribution || {}));
  } catch (err) {
    console.warn('OscAir attribution could not be saved:', err);
  }
}

export function getAttribution() {
  return readStoredAttribution();
}

export function captureAttributionFromSearch(search) {
  if (typeof window === 'undefined') return null;

  let params;
  try {
    params = new URLSearchParams(search || '');
  } catch (err) {
    console.warn('OscAir attribution URL params could not be parsed:', err);
    return readStoredAttribution();
  }

  const existing = readStoredAttribution() || {};
  const hasFreshUtm = UTM_KEYS.some((key) => params.has(key));
  const code = params.get('code');
  const landingPath = window.location?.pathname || '';

  if (!hasFreshUtm && !code) {
    return existing && Object.keys(existing).length > 0 ? existing : null;
  }

  const next = { ...existing };

  if (hasFreshUtm) {
    UTM_KEYS.forEach((key) => {
      if (params.has(key)) {
        next[key] = params.get(key) || '';
      }
    });
    next.captured_at = new Date().toISOString();
    if (landingPath) {
      next.landing_path = landingPath;
    }
  } else if (!next.captured_at) {
    next.captured_at = new Date().toISOString();
  }

  if (code) {
    next.coupon = code.trim().toUpperCase();
  }

  writeStoredAttribution(next);
  return next;
}

export function setAttributionCoupon(coupon) {
  const trimmed = String(coupon || '').trim().toUpperCase();
  const existing = readStoredAttribution() || {};
  const next = {
    ...existing,
    coupon: trimmed || undefined,
    captured_at: existing.captured_at || new Date().toISOString()
  };

  if (!trimmed) {
    delete next.coupon;
  }

  writeStoredAttribution(next);
  return next;
}

export function attributionEventParams() {
  const attribution = readStoredAttribution();
  return {
    coupon: attribution?.coupon || undefined,
    campaign_source: attribution?.utm_source || undefined
  };
}

export function attributionBookingPayload() {
  const attribution = readStoredAttribution();
  if (!attribution || Object.keys(attribution).length === 0) return undefined;
  return {
    utm_source: attribution.utm_source || undefined,
    utm_medium: attribution.utm_medium || undefined,
    utm_campaign: attribution.utm_campaign || undefined,
    coupon: attribution.coupon || undefined,
    landing_path: attribution.landing_path || undefined
  };
}
